<template>
  <div class="flex items-center gap-3">
    <NButton variant="flat" color="gray" class="flex-1" @click="remove()">
      <NText variant="caption1" weight="bold">
        {{ t('common.refuse') }}
      </NText>
    </NButton>

    <NButton
      v-gid="{
        module: 'order',
        screen: 'home',
        section: 'deleteOrderDialog',
        component: isAlgorithmOrder(order)
          ? `cancel${orderType}OrderButton`
          : 'cancelOrderButton',
      }"
      variant="fill"
      color="red"
      class="flex-1"
      :disabled="loadingDeleteOrder"
      :loading="loadingDeleteOrder"
      @click="handleDeleteOrder"
    >
      <NText variant="caption1" weight="bold">
        {{ t('modules.order.cancelOrder') }}
      </NText>
    </NButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { OrderItem, OrderTypeEnum } from '@libs/api-reference';
import { useDialog } from '@negar/core';
import { isAlgorithmOrder } from '@core/order';

const emit = defineEmits<{
  (e: 'deleteOrder', value: { selectedOrder: OrderItem }): void;
}>();

const props = defineProps<{
  order: OrderItem;
  loadingDeleteOrder: boolean;
}>();

const { t } = useI18n();

const { remove } = useDialog();

const orderType = computed(() => {
  return OrderTypeEnum[props.order.orderType] as string;
});

const handleDeleteOrder = () => {
  emit('deleteOrder', { selectedOrder: props.order });

  remove();
};
</script>
